// Configuration API
const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_EP_URI;

export interface CodeReviewMember {
  lastname: string | null;
  firstname: string | null;
  gitlab_username: string | null;
}

export interface CodeReviewGroup {
  id: number;
  name: string;
  td_group: string | null;
  is_sandbox: boolean;
  gitlab_web_url: string | null;
  members: CodeReviewMember[];
}

export interface CodeBranch {
  name: string;
  sha: string;
  last_commit_title: string | null;
  last_commit_author: string | null;
  last_commit_date: string | null;
}

// content absent si le fichier est binaire (binary) ou trop gros pour être affiché (too_large)
export interface CodeFile {
  path: string;
  size: number;
  content?: string;
  binary?: boolean;
  too_large?: boolean;
}

async function callApi<T>(path: string, accessToken: string): Promise<{ message: string; data: T }> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
  });

  const json = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(json.message || `HTTP error! status: ${response.status}`);
  }

  return json;
}

// Revue de code (enseignant·es) : lecture seule des dépôts GitLab des groupes projet
class CodeReviewService {

  async listGroups(accessToken: string): Promise<CodeReviewGroup[]> {
    const json = await callApi<CodeReviewGroup[]>('/code-review/groups', accessToken);
    return json.data;
  }

  async listBranches(groupId: number, accessToken: string): Promise<CodeBranch[]> {
    const json = await callApi<CodeBranch[]>(`/code-review/groups/${groupId}/branches`, accessToken);
    return json.data;
  }

  async listFiles(groupId: number, ref: string, accessToken: string): Promise<string[]> {
    const json = await callApi<string[]>(`/code-review/groups/${groupId}/tree?ref=${encodeURIComponent(ref)}`, accessToken);
    return json.data;
  }

  async getFile(groupId: number, ref: string, path: string, accessToken: string): Promise<CodeFile> {
    const query = `ref=${encodeURIComponent(ref)}&path=${encodeURIComponent(path)}`;
    const json = await callApi<CodeFile>(`/code-review/groups/${groupId}/file?${query}`, accessToken);
    return json.data;
  }
}

export const codeReviewService = new CodeReviewService();
